import { extractValuesFromObject } from '@qapline/helpers';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQuery, baseQueryWithAuthRefresh } from './baseQuery';
import { ApiCacheTags } from './tags';

export const baseApiService = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQueryWithAuthRefresh,
    tagTypes: extractValuesFromObject(ApiCacheTags),
    endpoints: () => ({}),
});

export const unauthenticatedApiService = createApi({
    reducerPath: 'unauthenticatedApi',
    baseQuery: baseQuery,
    tagTypes: extractValuesFromObject(ApiCacheTags),
    endpoints: () => ({}),
});

export * from './baseQuery';
export * from './tags';
